
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Heart, Trash2 } from "lucide-react";
import { JournalEntry } from "./types";

interface GridViewEntryProps {
  entry: JournalEntry;
  onLike: (id: string) => void;
  onDelete: (id: string) => void;
}

export const GridViewEntry = ({ entry, onLike, onDelete }: GridViewEntryProps) => {
  return (
    <motion.div
      key={entry.id}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.2 }}
    >
      <Card className="p-6 space-y-4 hover:shadow-lg transition-shadow h-full">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-xl font-semibold">{entry.title || "Untitled Entry"}</h3>
            <p className="text-sm text-gray-500">
              {new Date(entry.created_at).toLocaleDateString()}
            </p>
          </div>
          <div className="flex gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onLike(entry.id)}
            >
              <Heart className={`h-5 w-5 ${entry.likes > 0 ? 'fill-red-500 text-red-500' : 'text-gray-500'}`} />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onDelete(entry.id)}
            >
              <Trash2 className="h-5 w-5 text-gray-500" />
            </Button>
          </div>
        </div>

        <p className="text-gray-600">{entry.notes.text}</p>

        {entry.notes.images?.length > 0 && (
          <div className="grid grid-cols-2 gap-2">
            {entry.notes.images.map((image: string, index: number) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                className="relative"
              >
                <img
                  src={image}
                  alt={`Recipe image ${index + 1}`}
                  className="w-full h-32 object-cover rounded-lg"
                />
              </motion.div>
            ))}
          </div>
        )}
      </Card>
    </motion.div>
  );
};
